<template>
  <div class="vis-approval-queue-tooltip ba-px-5 ba-py-5 ba-text-white ba-bg-base-strong ba-rounded">
    <h5 class="ba-mb-2 ba-text-lg ba-font-semibold">{{ title }}</h5>
    <p class="ba-text-base ba-opacity-50">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "vis-approval-queue-tooltip",
  props: {
    queueType: {
      type: String,
      default: 'параллельное'
    }
  },
  computed: {
    title() {
      return this.queueType === "параллельное" ?
        "Параллельное согласование" :
        "Последовательное согласование"

    },
    description() {
      return this.queueType === "параллельное" ?
        "Согласование выполняется одновременно всеми участниками" :
        "Согласование выполняется по списку участников последовательно, т.е. пока документ не согласован первым участником, второму он не поступает на согласование"

    }
  }
}
</script>
